import { Injectable }    from '@angular/core';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { environment } from '../../../environments/environment';
import { AuthService } from '../login/auth.service';

@Injectable()
export class ProfileService {

    private headers: Headers;
    private url = environment.apiUrl;

    constructor(private http: Http, private authService: AuthService) {
        this.headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authService.getAuth().token})
    }

    public updateInvoiceData(data: InvoiceData): Promise<any> {
        return this.http
            .post(this.url+'/me/invoice', data, {headers: this.headers})
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    public getInvoiceData(): Promise<InvoiceData> {
        return this.http
            .get(this.url+'/me/invoice', {headers: this.headers})
            .toPromise()
            .then(res => res.json().invoiceData as InvoiceData)
            .catch(this.handleError);
    }

    public updateProfileData(data: ProfileData): Promise<any> {
        return this.http
            .post(this.url+'/me/profile', data, {headers: this.headers})
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

    public changePassword(data: PasswordData) {
        return this.http
            .post(this.url+'/me/password', data, {headers: this.headers})
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    public changeEmail(data: EmailData): Promise<any> {
        return this.http
            .post(this.url+'/me/email', data, {headers: this.headers})
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    public updateNotifications(data: NotificationsData): Promise<any> {
        return this.http
            .post(this.url+'/me/notifications', data, {headers: this.headers})
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    public getProfile(): Promise<any> {
        return this.http
            .get(this.url+'/me', {headers: this.headers})
            .toPromise()
            .then(res => res.json().user)
            .catch(this.handleError);
    }
}

export class InvoiceData {
    public companyName: string = "";
    public companyVat: string = "";
    public companyAddress: string = "";
    public companyZip: string = "";
    public companyCity: string = "";
    public companyCountry: number = 0;
    public remember: boolean = false;
}

export class ProfileData extends InvoiceData{
    public firstName: string = "";
    public lastName: string = "";
    public address: string = "";
    public zip: string = "";
    public city: string = "";
    public country: number = 0;
    public email: string = "";
}

export class PasswordData {
    public oldPassword: string = "";
    public newPassword: string = "";
}

export class EmailData {
    public email: string = "";
}

export class NotificationsData {
    public notifyAd: boolean;
    public notifyProfile: boolean;
    public notifyNews: boolean;
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/profile/profile.service.ts